import { toast } from "react-toastify";

export const errorHandler = (err: any): { data?: any; error: any; } => {
	const error = err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Une erreur est survenue';
	toast.error(error);
	return { error };
}
